import lecturerReducer from "./lecturerReducer";

const lecturerReducers = {
    lecturer: lecturerReducer
};

export default lecturerReducers;